import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pointsrecord" }

import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';
import dayjs from 'dayjs';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const getFullUrl = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    return url;
  }
  return useApi().baseUrl + url;
};

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();

const conditionsInitValue = {};

// 创建列定义
// eslint-disable-next-line max-lines-per-function
const createColumns = () => [
  {
    name: 'userId',
    label: '用户',
    type: 'remoteSearchSelect',
    fetchOptions: async(query) => {
      const res = await useApi().userApi.pageUsersuser({
        conditions: {
          meta: `phone": "%${query}%"` as any,
        },
        pageQuery: {
          page: 0,
          pageSize: 10,
        },
      });
      return res.data.data?.data?.map((item: any) => ({
        label: `${item.meta.name}(${item.meta.phone})`,
        value: item.id,
      })) || [];
    },
    placeholder: '搜索手机号',
    isCondition: true,
    hideTable: true,
    width: 120,
  },

  {
    name: 'userInfo',
    label: '用户信息',
    type: 'string',
    width: 200,
    render(scope: any) {
      const { userInfo } = scope.row;
      if (!userInfo) {
        return <span>-</span>;
      }
      const { avatar, name, phone } = userInfo;
      return (
        <div class="user-info-cell">
          <el-avatar
            size={40}
            src={avatar ? getFullUrl(avatar) : ''}
          >
            {name ? name.charAt(0) : '?'}
          </el-avatar>
          <div class="user-detail">
            <div class="user-name">{name || '-'}</div>
            <div class="user-phone">{phone || '-'}</div>
          </div>
        </div>
      );
    },
  },
  {
    name: 'amount',
    label: '积分数量',
    type: 'string',
    width: 120,
  },
  {
    name: 'reason',
    label: '原因',
    type: 'string',
    isCondition: true,
    width: 200,
  },
  {
    name: 'timeRange',
    label: '时间',
    type: 'datepick',
    isCondition: true,
    hideTable: true,
    clearable: true,
    pickType: 'datetimerange',
    defaultTime: [
      dayjs().startOf('day')
        .toDate(), dayjs().endOf('day')
        .toDate(),
    ],
    width: 180,
  },
  {
    name: 'createTime',
    label: '时间',
    type: 'string',
    width: 180,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = () => {
  columns.value = createColumns();
};

const operates: { name: string; label: string; type: string }[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().pointsRecordApi.pagePointsRecordpointsRecord({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key as keyof typeof conditions] = val;
        return conditions;
      }, {} as Record<string, unknown>),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
      timeRange: filter.conditions.timeRange && {
        start: filter.conditions.timeRange[0],
        end: filter.conditions.timeRange[1],
        field: 'createTime',
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(HpsfirProTable), {
      ref_key: "tableRef",
      ref: tableRef,
      paginations: { pageSize: 20 },
      "page-layout": "total, sizes, prev, pager, next",
      columns: columns.value,
      "get-data": _unref(getData),
      loading: loading.value,
      "row-key": "id",
      operates: operates,
      "codition-init-values": conditionsInitValue,
      "hide-create": true,
      "hide-delete": true,
      "hide-edit": true
    }, null, 8, ["columns", "get-data", "loading"])
  ]))
}
}

})